<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Miners, Strikers and State Police</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Bootlegging, Drinking and Gambling</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Bruno Family</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Seeds of a Revolt</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. The McAloose Faction</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. A Parade Ends in Bloodshed</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Election of 1934</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. The Funerals</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Prisoner Joseph J. Bruno</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. The Trials</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. The Legend of Lewis Buono Begins</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Joe Checks Out of the Bruno Hotel</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Anatomy of an Escape</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Frank Miller Comes Home</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. The Aftermath</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. Around in a Circle</span></p>
<p class="toc1"><span href="#/bib" title="Link target outside of Sample">Sources</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?72bc61d0